export default __webpack_public_path__ + "static/media/deal-14.09075cc1.webp";